module.exports = __webpack_public_path__ + "74f40d95ce52e885e82008897d83c93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/survey2.png
// module id = 478
// module chunks = 0